import { type ComponentProps } from "react"
import { cn } from "@ui/utils"

interface ChatLoadingIndicatorProps extends ComponentProps<"div"> {
  visible?: boolean
}

export function ChatLoadingIndicator({ visible = true, className, ...props }: ChatLoadingIndicatorProps) {
  return (
    <div
      role="status"
      aria-label="Thinking"
      className={cn("size-8 shrink-0 overflow-hidden", !visible && "hidden", className)}
      {...props}
    >
      {/* Keep both gifs mounted so their animation does not restart between streaming states. */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/slant_icon_loading_sand.gif" alt="" className="size-full scale-[1.3] dark:hidden" />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/slant_icon_loading_sand_dark.gif" alt="" className="hidden size-full scale-[1.3] dark:block" />
    </div>
  )
}
